import React from "react";
import nmmain from '../nmmain.png'
import nm1 from '../nm1.png'
import Banner from './Banner.js'
import AboutSection from './AboutSection.js'
import CateringForm from './CateringForm'
import Footer from './Footer'
import '../App.css'
import Rust from '../fonts/IntroRustBase.ttf'
import EventsBanner from "./EventsBanner";
import ContactSnip from "./ContactSnip";
import sihb from "../sihb.png"
import kraken from '../kraken.png'
import UW from "../UW.png"
import meta1 from "../meta1.png"
import mckshoot from "../mckshoot.png"
import DishFeature from "./DishFeature.js"
import ThinBanner from "./ThinBanner.js"
import summer from '../SummerMenu1.png'
import Photogal from "./Photogal.js";

import plate1 from '../plate1.jpg'
import MultiMenu from '../Multi-Menu.png'

import beef from '../BeefMenu4.png'
import chicken from '../ChickenMenu.png'
import salmon3 from '../SalmonMenu5.png'
import Hero from './Hero.js'
import Smokey from '../SmokeySalmonMenu.png'
import salmonberry from '../salmonb.png'
import border1 from '../Border1.png'
import olivia from '../olivia.png'
import flower from '../flower.png'
import BoxFaq2 from './BoxFaq2'
import Jason from '../Jason1.png'
import Shawn from '../shawn.png'
import StrawberryMoon from '../2026SpringBox.png'



export default function Home () {

  

    return (
      <div className="pt-24 h-full bg-black min-h-screen">
     
      

        <img
          src={plate1}
          alt="Photo of food made by Jason A Vickers"
          className="absolute h-full w-full object-cover brightness-50 "
        />

        <div className="relative mx-auto max-w-5xl px-4 py-10 mt-20 text-center lg:py-32">
          <div
            id="home-text"
            className="flex flex-col items-center justify-center space-y-8 lg:flex-row lg:space-y-0 lg:space-x-8"
          >
            <div className="flex-1">
              <h1
                id="rust"
                className="text-5xl  tracking-tight text-white md:text-6xl lg:text-left"
              >
                Catering for Events with a Traditional Indigenous Twist
              </h1>
            </div>

            <div className="flex-1">
              <p
                id="white"
                className="rounded-lg bg-black bg-opacity-60 p-5 text-lg leading-8 text-white md:text-xl lg:text-left"
              >
                Chef Vickers includes the incredible bounty of traditional foods,
                knowledge, and foodways Native Country has to offer to present
                beautifully curated meals, catered events, classes, and stories as
                Natoncks Metsu.
              </p>
            </div>
          </div>

      <div className="mt-16 flex flex-col items-center justify-center space-y-2 lg:flex-row lg:space-y-0 lg:gap-x-4 lg:items-stretch">     
        <a
        href="https://checkout.square.site/merchant/ML56PV1EBXGNX/checkout/VV4ISJ3RKVOHEDW37WKLOXE6"
        target="_blank"
        className="rounded-md bg-red px-3.5 py-2.5 text-sm font-bold text-white shadow-sm transition duration-700 hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
      >
        Strawberry Moon Gift Box
      </a>
      
      <a
        href="/Catering"
        target="_blank"
        className="rounded-md bg-red px-3.5 py-2.5 text-sm font-bold text-white shadow-sm transition duration-700 hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
      >
        Catering Request
      </a>
      
    </div>
  </div>

 <section className="relative overflow-hidden bg-black">
      {/* Background */}
      <div className="absolute inset-0 " />

      {/* Glow Effects */}
      <div className="" />
      <div className="" />

      <div className="relative z-10 mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 py-12 md:flex-row md:px-12 ">
        
        {/* Left Content */}
        <div className="max-w-2xl text-center md:text-left">
          <p className="mb-5 inline-block rounded-full border border-red bg-pink-500/10 px-4 py-1 text-sm font-medium tracking-wide text-white backdrop-blur">
            Limited Edition <span class="text-beige">• </span>Spring Collection
          </p>

          <h1 id="rust" className="text-5xl leading-none tracking-tight text-white sm:text-6xl md:text-7xl">
            Strawberry
            <span className="block bg-gradient-to-r from-pink-300 via-rose-400 to-red-400 bg-clip-text text-transparent">
              Moon
            </span>
            Gift Box
          </h1>

       

          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:justify-center md:justify-start">
           
               <a
              href="https://checkout.square.site/merchant/ML56PV1EBXGNX/checkout/VV4ISJ3RKVOHEDW37WKLOXE6"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-2xl  px-5 py-2 mb-3  hover:bg-red  text-base font-medium text-white backdrop-blur transition  hover:text-white group inline-flex items-center justify-center  rounded-2xl bg-gradient-to-r from-beige to-red"
            >
              
           
           
              Shop the Box

            
            </a>
          </div>
        </div>

        {/* Right Visual */}
        <div className="relative flex items-center justify-center">
          
          <div className="" />

          <div className="" />

          {/* Gift Box Card */}
          <div className="relative  rounded-[32px] border border-white/10 bg-white/10 p- shadow-2xl backdrop-blur-xl sm:w-[550px]">
            <div className="rounded-3xl bg-gradient-to-br from-pink-500 to-rose-700 p-8 shadow-inner">
              
              <div className="flex items-center justify-between">
                <span className="text-md font-semibold uppercase tracking-[0.3em] text-red">
                  Strawberry Moon
                </span>

                <span className="rounded-full bg-beige px-3 py-2 font-bold text-sm text-black">
                  2026
                </span>
              </div>

              <div className="mt-10">
                <div className="text-6xl"><img src={StrawberryMoon} class="h-[200px]"></img></div>

              

                <p className="mt-8 text-md leading-relaxed text-white">
                  Inside, you’ll find a thoughtfully curated collection of seasonal, locally handcrafted, Native-made goodies, each created to honor the land, the harvest, and the joy of this season:
                
                
                <ul class="py-3">
                <li>✨ Strawberry Sumac Honey</li>
                             <li>✨ Hibiscus Strawberry Caramels</li>
                <li>✨ Strawberry BBQ Sauce</li>
                <li>✨ Nettle Cookies</li>
                <li>✨ Strawberry Lavender Soda Syrup</li>
                <li>✨ Dakota Sage & Apple Soda Syrup</li>

                </ul>

                  Every item was made with intention, inspired by spring’s excitement and the sweet explosion of new growth. Chef Jason, Chef Shawn & Chef Olivia are so proud to share these creations with you and welcome the season together. Taxes already apply!


                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="bg-[#1d1d1d] ">
    
    <div id="height" class="  text-center   ">
      <p class="text-white  pt-16  mb-3 text-xl italic"><span class="text-red">-</span> Downloadable <span class="text-red">-</span></p>
    <h2 id="rust" className=" text-white md:text-6xl tracking-tight text-gray-900 text-4xl">Sample Menus</h2>
    <div class="grid md:grid-cols-3 grid-cols-1   py-4 px-6 ">

            <div class="mb-10">
         
            <img
                  src={beef}
                  alt="Beef Menu"
                  className="object-contain lg:px-0 lg:w-3/4 mb-8   justify-center m-auto mt-12 px-8"
                />    

            <a
              href="BeefMenu2025.pdf" target="_blank"
              className="rounded-md m-4 mx-8 md:mx-2 bg-blue px-3.5 py-2.5  lg:text-lg  md:text-sm sm:text-md font-bold text-white shadow-sm hover:bg-red transition duration-700 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
          
              Download Beef Menu
            </a>
            </div>    
            
            <div class="mb-10">
            
            <img
                  src={chicken}
                  alt="Chicken Menu"
                  className="object-contain lg:w-3/4 mb-8 md:px-8 lg:px-0   justify-center m-auto mt-12 px-8 "
                />  

            <a
              href="ChickenMenu2025.pdf" target="_blank"
              className="rounded-md m-4 mx-8  md:mx-2 bg-blue px-3.5 py-2.5  lg:text-lg  md:text-sm sm:text-md font-bold text-white shadow-sm hover:bg-red transition duration-700 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
            
              Download Chicken Menu 
                         </a>
            </div>
      

            <div class="mb-10">
            
            <img
                  src={salmon3}
                  alt="Salmon Menu"
                  className="object-contain lg:w-3/4 mb-8 md:px-8 lg:px-0  justify-center m-auto mt-12 px-8 "
                />  
            <a
              href="SalmonMenu2025.pdf" target="_blank"
              className="rounded-md m-4 mx-8 nowrap md:mx-2 bg-blue px-3.5 py-2.5  lg:text-lg  md:text-sm sm:text-md font-bold text-white shadow-sm hover:bg-red transition duration-700 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            > 

           
              Download Salmon Menu 
                         </a>
            </div>


            <div class="mb-10">
            
            <img
                  src={Smokey}
                  alt="Smokey Salmon Menu"
                  className="object-contain lg:w-3/4 mb-8 md:px-8 lg:px-0  justify-center m-auto mt-12 px-8 "
                />  
            <a
              href="SmokeySalmonMenu2025.pdf" target="_blank"
              className="rounded-md m-4 mx-8 nowrap md:mx-2 bg-blue px-3.5 py-2.5  lg:text-lg  md:text-sm sm:text-md font-bold text-white shadow-sm hover:bg-red transition duration-700 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            > 

           
              Download Smokey Salmon Menu 
                         </a>
            </div>


            <div class="mb-10">
            
            <img
                  src={MultiMenu}
                  alt="Summer Sample Menu"
                  className="object-contain lg:w-3/4 mb-8 md:px-8 lg:px-0   justify-center m-auto mt-12 px-8 "
                />  

            <a
              href="Multi-Menu2025.pdf" target="_blank"
              className="rounded-md m-4 mx-8  md:mx-2 bg-blue px-3.5 py-2.5 lg:text-lg  md:text-sm sm:text-md font-bold text-white shadow-sm hover:bg-red transition duration-700 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
           
              Download Multi-Menu
                         </a>
            </div>
        
        </div>
        
        


        </div>
        
        



    </div>



    
        
        <EventsBanner />

        <div id="marginstuff">
          
        <AboutSection />

        </div>
        
        </div>
    )
}




/* <h1 className="italic text-center p-3 text-xl mt-6">Catered events for</h1>

    <div id="redblock" className="bg-red"></div>

        <div id="business" className="grid lg:grid-cols-5  sm:grid-cols-2 gap-8 p-7 mb-3 mt-8 ">
            <a href="https://www.sihb.org/" target="_blank" rel="noreferrer"><div><img src={sihb} className="m-auto hover:scale-125 transition duration-500" alt="Seattle Indian Health Board Logo" /><p className="text-center p-4">Seattle Indian<br></br>Health Board</p></div></a>

            <a href="https://www.nhl.com/kraken/" target="_blank" rel="noreferrer"><div><img src={kraken} className="m-auto hover:scale-125 transition duration-500"  alt="Seattle Kraken Logo"  /><p className="text-center p-4">Seattle Kraken</p></div></a>
            <a href="https://www.washington.edu/" target="_blank" rel="noreferrer"> <div><img src={UW} className="m-auto hover:scale-125 transition duration-500" alt="University of Washington Logo" /><p className="text-center p-4">University of Washington</p></div></a>
            <a href="https://www.muckleshoot.nsn.us/" target="_blank" rel="noreferrer"><div><img src={mckshoot} className="m-auto hover:scale-125 transition duration-500" alt="Muckleshoot Indian Health tribe" /><p className="text-center p-4">Muckleshoot Indian<br></br>Health Tribe</p></div></a>   
            <a href="https://about.meta.com/" target="_blank" rel="noreferrer"><div><img src={meta1} className="m-auto hover:scale-125 transition duration-500" alt="Meta Logo" /><p className="text-center p-4">Meta</p></div></a>
       


        </div>






         <div id="home" className="relative isolate overflow-hidden pt-12 ">

        <div className="bg-[#FF9496] text-white py-12 px-6 w-full bg-left">

          <div className="max-w-6xl mx-auto items-center text-center m-auto justify-center sm:justify-between text-center " >
            <div>
            <p className="text-[#A00C24] text-3xl bold  mt-20 font-bold" id="ovo-regular">Announcing Matriarch Gift Box Coming Soon!</p>
            </div>

            <div>
              <p class="text-lg mt-4 underline" ><a target="_blank" href="https://squareup.com/customer-programs/enroll/yfSkDpfA2Mbb?utm_medium=copied-link&utm_source=online">Click here to submit your email and stay up to date</a></p>
          
            </div>
          </div>

        </div>

        <




<a
        href="/Meal-Prep"
        target="_blank"
        className="rounded-md border-red bg-white px-4 py-2.5 text-sm font-bold text-red shadow-sm transition duration-700 hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
      >
        Meal Prep
      </a>




        */